import { LOCK_WSPOS, LOCK_WSPOS_SUCCESSFUL, LOCK_WSPOS_FAILED } from './actionTypes';

export const lockWSPosition = (wspos, token, history) => {
    return {
        type: LOCK_WSPOS,
        payload: { wspos, token, history }
    }
}

export const lockWSPositionSuccessful = (msg) => {
    return {
        type: LOCK_WSPOS_SUCCESSFUL,
        payload: msg
    }
}

export const lockWSPositionFailed = (msg) => {
    return {
        type: LOCK_WSPOS_FAILED,
        payload: msg
    }
}
